import { UntypedFormGroup } from '@angular/forms';
import { BusinessDataLabels } from '../business-data-labels/business-data-labels';
import { BusinessDataOptions } from '../business-data-options/business-data-options';

/**
 * Form object to used to instantiate a business data form component
 */
export class BusinessDataFormObject {
  /**
   * @constructor
   */
  constructor(
    public labels: BusinessDataLabels,
    public formGroup: UntypedFormGroup,
    public options: BusinessDataOptions
  ) {}
}
